/**
 * A public search box on a mental-health site receives queries from people in
 * crisis. Those queries get emergency resources above the results.
 *
 * Matching runs here, in the browser, for two reasons: what someone types in
 * that state should not reach a server log or an analytics event, and the
 * notice has to appear instantly rather than after a round trip.
 *
 * Deliberately tuned to over-trigger rather than under-trigger. Showing a
 * helpline to someone who did not need it costs a glance; missing someone who
 * did costs more.
 */

const TERMS: Record<string, string[]> = {
    es: [
        "suicid",
        "matarme",
        "me quiero morir",
        "quiero morir",
        "no quiero vivir",
        "no quiero seguir",
        "quitarme la vida",
        "acabar con todo",
        "hacerme dano",
        "hacerme daño",
        "autolesion",
        "autolesión",
        "cortarme",
        "sobredosis",
        "no aguanto mas",
        "no aguanto más",
    ],
    en: [
        "suicid",
        "kill myself",
        "want to die",
        "end my life",
        "self harm",
        "self-harm",
        "hurt myself",
        "cutting myself",
        "overdose",
        "cant go on",
        "can't go on",
    ],
};

/** Lowercase and strip accents, so "autolesión" and "autolesion" both match. */
export function fold(raw: string): string {
    return raw
        .normalize("NFKD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
}

export function isCrisisQuery(query: string, language = "es"): boolean {
    const folded = fold(query);
    if (folded.length < 4) return false;

    const lists = [TERMS[language.slice(0, 2)] ?? [], TERMS.es, TERMS.en];
    return lists.some((list) => list.some((term) => folded.includes(fold(term))));
}
